// extracted by mini-css-extract-plugin
export default {"root":"ZKAttestation_root__ODkSV"};